<script>
    import {link} from 'svelte-spa-router'
    import { t } from '../i18n.js'
    import { isMobile } from '../store/stores.js'

    const emails = [
        'datajalostamo(at)kuopio.fi',
    ]

    const navLinks = [
        {
            name: 'nav.home',
            location: '/'
        },
        {
            name: 'nav.interfaces',
            location: '/interfaces'
        },
        {
            name: 'nav.import-interfaces',
            location: '/interfaces-import'
        },
        {
            name: 'nav.info',
            location: '/info'
        }
    ]
</script>

<div class="relative bottom-0">
    <div class="bg-navy text-white pt-12 pb-4">
        <div class="container grid grid-cols-1 md:grid-cols-3">
            <div class="mb-16 mx-8 md:m-none md:justify-self-center">
                <p class="text-sm uppercase font-semibold mb-4">{$t('footer.contact-title')}</p>
                {#each emails as email}
                    <p class="block mb-4">{email}</p>
                {/each}
                <a class="text-sm uppercase font-semibold mb-4 block hover:text-lighter-blue transition duration-150" href="https://kuopio.oncloudos.com/kuulutus/6380738950225956661.1671785501882.PDF" target=_blank>{$t('footer.privacy-policy-title')}</a>
                <a class="text-sm uppercase font-semibold mb-4 block hover:text-lighter-blue transition duration-150" href="/terms-conditions" use:link>{$t('footer.terms-conditions-title')}</a>
                <a class="text-sm uppercase font-semibold mb-4 block hover:text-lighter-blue transition duration-150" href="/accessibility" use:link>{$t('footer.accessibility-title')}</a>
                <!-- <a class="text-sm uppercase font-semibold mb-4 block hover:text-lighter-blue transition duration-150" href="https://profile.datajalostamo.fi/" target=_blank>{$t('footer.identity-title')}</a> -->
                <a class="text-sm uppercase font-semibold mb-4 block hover:text-lighter-blue transition duration-150" href="https://id.datajalostamo.fi/" target=_blank>{$t('footer.identity-title')}</a>
            </div>
            <div class="mb-16 mx-8 md:m-none md:justify-self-center">
                {#each navLinks as navLink}
                    <a class="text-sm uppercase font-semibold mb-4 block hover:text-lighter-blue transition duration-150" href="{navLink.location}" use:link>{$t(navLink.name)}</a>
                {/each}
            </div>
        </div>
    </div>
    <div class="bg-light-navy {!$isMobile ? 'footer' : ''}">
        <img src="img/datajalostamo-logo-oneline.png" alt="{$t('footer.datajalostamo-logo-alt')}" class="w-72 py-8 mx-auto">
    </div>
</div>

<style>
    .footer {
        filter: drop-shadow(0px -4px 30px rgba(0, 0, 0, 0.15));
    }

    .footer::before {
        content: '';
        position: absolute;
        top: -4rem;
        height: 4rem;
        width: 100%;
        background: linear-gradient(
        30deg,
        transparent 25%,
        theme('colors.light-navy') 25%,
        theme('colors.light-navy') 40%,
        transparent 40%
    ),
          linear-gradient(
        -30deg,
        transparent 25%,
        theme('colors.light-navy') 25%,
        theme('colors.light-navy') 40%,
        transparent 40%
    );
        background-size: 75px 100px;
    }
</style>